module.exports = __webpack_public_path__ + "media/eight.19fc8298.wav";